import { Button, Group } from '@mantine/core';
import type { DashboardRow } from '../api-client.ts';
import { tokens } from '../ui/tokens.ts';
import {
  canAllocate,
  canCancel,
  canCheckIn,
  canComplete,
  canMarkNoShow,
} from '../domain/reservation-actions.ts';

interface Props {
  readonly reservation: DashboardRow;
  readonly onAllocate: () => void;
  readonly onCheckIn: () => void;
  readonly onComplete: () => void;
  readonly onCancel: () => void;
  readonly onNoShow: () => void;
  readonly busy?: boolean;
}

export function LifecycleActions({
  reservation,
  onAllocate,
  onCheckIn,
  onComplete,
  onCancel,
  onNoShow,
  busy,
}: Props) {
  const isBusy = busy === true;
  const status = reservation.status;
  const showAllocate = canAllocate(status);
  const showCheckIn = canCheckIn(status);
  const showComplete = canComplete(status);
  const showCancel = canCancel(status);
  const showNoShow = canMarkNoShow(status);

  if (!showAllocate && !showCheckIn && !showComplete && !showCancel && !showNoShow) {
    return null; // terminal state
  }

  return (
    <Group gap="xs" mt="xs">
      {showAllocate && (
        <Button
          size="sm"
          radius="xl"
          color={tokens.color.mantine['primary']}
          onClick={onAllocate}
          disabled={isBusy}
        >
          分配格子
        </Button>
      )}
      {showCheckIn && (
        <Button
          size="sm"
          radius="xl"
          color={tokens.color.mantine['lifecycleCheckIn']}
          onClick={onCheckIn}
          disabled={isBusy}
        >
          客人到場
        </Button>
      )}
      {showComplete && (
        <Button
          size="sm"
          radius="xl"
          color={tokens.color.mantine['primary']}
          onClick={onComplete}
          disabled={isBusy}
        >
          結束場次
        </Button>
      )}
      {showNoShow && (
        <Button
          size="sm"
          variant="subtle"
          color={tokens.color.mantine['danger']}
          radius="xl"
          onClick={onNoShow}
          disabled={isBusy}
        >
          客人未到
        </Button>
      )}
      {showCancel && (
        <Button
          size="sm"
          variant="subtle"
          color={tokens.color.mantine['neutral']}
          radius="xl"
          onClick={onCancel}
          disabled={isBusy}
        >
          取消
        </Button>
      )}
    </Group>
  );
}
